export const MerSETAReport = 'MerSETAReport/';
export const Populate = MerSETAReport + "Populate/";
export const GetWSPReportPreview = MerSETAReport + "MerSETAReportPreview/";